import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useSubmitStudentApplication } = getCRUDHooks({
  entityName: 'studentApplication',
  create: (
    values: { studentApplicationRawData: string },
    { studentApplicationId }: { studentApplicationId: string }
  ) =>
    clientApi
      .getOCClient()
      .helpers.studentApplication.studentApplication.id(studentApplicationId)
      .submit.create(values),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useSubmitStudentApplication,
};
